import { Tag, Row, Col } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CountWord = props => {
  const { current = 0, max = 2000, currentLimiti = 0, total = 5, isloggin } = props;
  const { t } = useTranslation('chat');
  let color = '#6C757D'; // 默认灰色
  const remaining = total - currentLimiti;
  const remainingRatio = remaining / total;

  if (!isloggin || currentLimiti >= total) {
    color = '#6C757D';
  } else if (remainingRatio <= 0.2) {
    color = '#A71D2A'; // 红色（≤1/5）
  } else if (remainingRatio < 0.5) {
    color = '#C35C00'; // 橙色（<1/2）
  } else {
    color = '#1E7E34'; // 绿色（≥1/2）
  }
  return (
    <Tag style={{ width: 240, padding: 0 }}>
      <Row style={{ width: '100%' }}>
        <Col
          span={12}
          style={{
            textAlign: 'center',
            backgroundColor: color,
            lineHeight: '18px',
            color: 'white',
            fontSize: 13,
          }}
        >
          {t('chat:quota')}: {currentLimiti > total ? total : currentLimiti}/{total}
        </Col>
        <Col
          span={12}
          style={{
            textAlign: 'center',
            lineHeight: '18px',
            fontSize: 13,
          }}
        >
          {current > max ? max : current}/{max} {t('chat:character')}
        </Col>
      </Row>
    </Tag>
  );
};

export default CountWord;
